export class PriceSaving {
  constructor(
    id,
    cur,
    unitPrice,
    prevUnitPrice,
    unitPriceAmount,
    prevUnitPriceAmount,
    savingAmount,
  ) {
    this.id = id;
    this.cur = cur;
    this.unitPrice = unitPrice;
    this.prevUnitPrice = prevUnitPrice;
    this.unitPriceAmount = unitPriceAmount;
    this.prevUnitPriceAmount = prevUnitPriceAmount;
    this.savingAmount = savingAmount;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new PriceSaving(
        input.id,
        input.cur,
        input.unit_price,
        input.prev_unit_price,
        +input.unit_price_amount,
        +input.prev_unit_price_amount,
        +input.saving_amount,
      )
    }

    return new PriceSaving();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => PriceSaving.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [PriceSaving.fromApiObject(input)];
    }

    return [];
  }
}